import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "geolocation-text"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 3,
  class: "geolocation-coords"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("span", {
    id: `geolocation-wrapper+${_ctx.id}`,
    class: "geolocation"
  }, [
    (!_ctx.hideButton)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "geolocation-button",
          density: _ctx.density,
          size: _ctx.size,
          variant: _ctx.geolocation ? (_ctx.useTextButton ? 'tonal' : 'flat') : 'outlined',
          elevation: _ctx.elevation,
          loading: _ctx.loading,
          icon: !_ctx.useTextButton ? _ctx.icon : false,
          "prepend-icon": _ctx.useTextButton ? _ctx.icon : '',
          color: _ctx.geolocationError ? 'red' : _ctx.color,
          onClick: _ctx.getLocation
        }, {
          default: _withCtx(() => [
            (_ctx.useTextButton)
              ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                  _createTextVNode(_toDisplayString(_ctx.label), 1)
                ])
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["density", "size", "variant", "elevation", "loading", "icon", "prepend-icon", "color", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.showTextProgress && _ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            size: _ctx.progressCircleSize,
            width: 2,
            color: _ctx.color,
            indeterminate: ""
          }, null, 8, ["size", "color"]),
          _cache[0] || (_cache[0] = _createTextVNode(" Fetching location "))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideText && !_ctx.useTextButton)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (_ctx.loading && _ctx.showTextProgress)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                size: _ctx.progressCircleSize,
                width: 2,
                color: _ctx.color,
                indeterminate: ""
              }, null, 8, ["size", "color"]))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          (_ctx.loading && _ctx.showTextProgress)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Fetching location"))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCoords)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          _createElementVNode("p", null, "Latitude: " + _toDisplayString(_ctx.geolocation?.latitude), 1),
          _createElementVNode("p", null, "Longitude: " + _toDisplayString(_ctx.geolocation?.longitude), 1)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}